module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"login":{"cta":"Login","forgot":"Forgot password?","messages":{"success":"Successfully logged in","fail":"Combination of password and username is incorrect","first":"This looks like you are installing new project, app wil try to create new user for you with specified name and password","network":"Network Error, is your API running?"}}}}')
  delete Component.options._Ctor
}
